module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.dataItems.length) ? _c('div', [_vm._v("\n    No activity at this time\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "10"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "div"
    }
  }, _vm._l((_vm.dataItems), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "clickable",
      class: {
        'slats': true, 'highlight': _vm.highlightForm == item._id
      },
      on: {
        "click": function($event) {
          return _vm.onRowClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "el-icon-success text-success"
    }), _vm._v(" "), (!item.isReaded) ? _c('strong', [_vm._v(_vm._s(item.form.title))]) : _c('span', [_vm._v(_vm._s(item.form.title))]), _vm._v("\n      - " + _vm._s(_vm.formatTimeAgo(item.createdAt)) + " ago\n\n    ")])
  }), 0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-muted loading-list"
  }, [_c('span', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n      Loading...\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isFullList && !_vm.loading) ? _c('div', {
    staticClass: "text-center loading-list"
  }, [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore($event)
      }
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-down"
  }), _vm._v("\n        More...\n      ")])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c331f3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/UnreadedSubmissionsList.vue
// module id = 399
// module chunks = 4